import React, { memo, useCallback } from 'react';

import DescriptionCell from './DescriptionCell';

const DescriptionCells = ({
  roles = [],
  fetchCompetency,
  functionId,
  description,
  competencyId,
  setAddNew = () => {},
}) => {
  const dataObj = useCallback((uuid) => (functionId ? description[uuid] : description.null), [description, functionId]);
  return (
    <>
      {roles?.map(({ uuid }) => (
        <DescriptionCell
          dataObj={dataObj(uuid)}
          key={`description-cell-${uuid}`}
          fetchCompetency={fetchCompetency}
          competencyId={competencyId}
          functionId={functionId}
          roleId={uuid}
          setAddNew={setAddNew}
        />
      ))}
    </>
  );
};

export default memo(DescriptionCells);
